import {useMemo, useState} from 'react'
import useSenderIdsOptions from '../../../hooks/useSenderIdsOptions'
import {useRouteManagement} from '../RouteManagementProvider'
import {FixedSizeList as List, ListChildComponentProps} from 'react-window'
import {KTIcon} from '../../../../_metronic/helpers'
import ListPlaceholder from '../../../utils/components/Skeleton/ListPlaceholder'

const Row = ({index, style, data}: ListChildComponentProps) => {
  const {setDestinationSenderIds, setSourceSenderIds} = useRouteManagement()

  const item = data.items[index]
  const selectionType = data.selectionType

  const onHandleSelect = () => {
    const formatedItem = {
      id: item.id,
      value: item.value,
    }

    if (selectionType === 'source') {
      setSourceSenderIds([formatedItem])
    }

    if (selectionType === 'destination') {
      setDestinationSenderIds([formatedItem])
    }
  }

  return (
    <div
      style={style}
      className='cursor-pointer bg-hover-danger rounded px-4 py-3'
      onClick={onHandleSelect}
    >
      {item.value}
    </div>
  )
}

const SenderSelection = () => {
  const {destinationSenderIds, sourceSenderIds, setShowSenderModal} = useRouteManagement()
  const {senderIdsOptions, isLoading} = useSenderIdsOptions()

  const [search, setSearch] = useState('')
  const [searchDestinationSender, setSearchDestinationSender] = useState('')

  const filteredItems = useMemo(() => {
    return senderIdsOptions.filter((item) =>
      item.value.toLowerCase().includes(search.toLowerCase())
    )
  }, [search, senderIdsOptions])

  const filteredDestinationSender = useMemo(() => {
    return senderIdsOptions.filter((item) =>
      item.value.toLowerCase().includes(searchDestinationSender.toLowerCase())
    )
  }, [searchDestinationSender, senderIdsOptions])

  const onClose = () => {
    setShowSenderModal(false)
  }

  return (
    <div className='d-flex gap-8'>
      <div>
        <h3>Source Sender</h3>
        <p className='p-4 bg-light rounded mb-3 text-gray-700'>
          {sourceSenderIds ? sourceSenderIds[0].value : 'Not Selected'}
        </p>

        {isLoading ? (
          <ListPlaceholder />
        ) : (
          <div className='bg-light w-100 mt-5 rounded'>
            <input
              placeholder='Search'
              type='text'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className='form-control custom-input'
            />
            <div className='w-100 px-4 py-4'>
              <List
                height={400}
                itemCount={filteredItems.length}
                itemSize={40}
                width={'100%'}
                itemData={{items: filteredItems, selectionType: 'source'}}
              >
                {Row}
              </List>
            </div>
          </div>
        )}
      </div>

      <div>
        <h3>Destination Sender</h3>
        <p className='p-4 bg-light rounded mb-3 text-gray-700'>
          {destinationSenderIds ? destinationSenderIds[0].value : 'Not Selected'}
        </p>

        {isLoading ? (
          <ListPlaceholder />
        ) : (
          <div className='bg-light w-100 mt-5 rounded'>
            <input
              placeholder='Search'
              type='text'
              value={searchDestinationSender}
              onChange={(e) => setSearchDestinationSender(e.target.value)}
              className='form-control custom-input'
            />
            <div className='w-100 px-4 py-4'>
              <List
                height={400}
                itemCount={filteredDestinationSender.length}
                itemSize={40}
                width={'100%'}
                itemData={{items: filteredDestinationSender, selectionType: 'destination'}}
              >
                {Row}
              </List>
            </div>
          </div>
        )}
      </div>

      <div>
        {sourceSenderIds ? (
          <>
            <div className='text-gray-800 fs-4 d-flex align-items-center gap-2'>
              Source
              <KTIcon iconName='arrow-right' className='fs-2hx' />
              Destination
            </div>
            <div className='text-gray-700 fs-4 d-flex align-items-center gap-2'>
              {sourceSenderIds[0].value}
              <KTIcon iconName='arrow-right' className='fs-2hx' />
              {destinationSenderIds ? destinationSenderIds[0].value : 'Not Selected'}
            </div>

            <div className='mt-10'>
              <button
                type='reset'
                className='btn btn-primary btn-sm me-3'
                onClick={onClose}
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_1'
              >
                Confirm
              </button>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}

export default SenderSelection
